const _ = "styles-module__drawer___LBZAU", e = "styles-module__drawer__box___qka5F", r = "styles-module__drawer__overlay___Nc468", d = "styles-module__drawer__header___IJipm", a = "styles-module__drawer__arrow___imBZ-", t = "styles-module__drawer__body___PV6Ag", o = {
  drawer: _,
  "drawer--maximized": "styles-module__drawer--maximized___nSmDY",
  "drawer-enter": "styles-module__drawer-enter___Liw4a",
  "drawer-enter-active": "styles-module__drawer-enter-active___Bd8SA",
  "drawer-exit-active": "styles-module__drawer-exit-active___9NR25",
  drawer__box: e,
  drawer__overlay: r,
  "drawer__overlay--grey": "styles-module__drawer__overlay--grey___rXYnm",
  "drawer__overlay--white": "styles-module__drawer__overlay--white___2JSIJ",
  drawer__header: d,
  drawer__arrow: a,
  drawer__body: t,
  "drawer__body-content": "styles-module__drawer__body-content___dIWOx",
  "grey-background": "styles-module__grey-background___-TtDz",
  "grey-background-enter": "styles-module__grey-background-enter___gzGfh",
  "grey-background-enter-active": "styles-module__grey-background-enter-active___wTB9k",
  "grey-background-exit-active": "styles-module__grey-background-exit-active___nzSTA"
};
export {
  o as default,
  _ as drawer,
  a as drawer__arrow,
  t as drawer__body,
  e as drawer__box,
  d as drawer__header,
  r as drawer__overlay
};
